'use strict';

var _reactTransformCatchErrors2 = require('react-transform-catch-errors');

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

var _reactTransformCatchErrors3 = _interopRequireDefault(_reactTransformCatchErrors2);

var _react = require('react');

var _redboxReact = require('redbox-react');

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireWildcard = require('babel-runtime/helpers/interop-require-wildcard')['default'];

exports.__esModule = true;

var _react2 = _interopRequireDefault(_react);

var _redux = require('redux');

var _reactRouter = require('react-router');

var _reactRedux = require('react-redux');

var _utils = require('../../utils');

var _reduxModulesPosts = require('redux/modules/posts');

var postsActions = _interopRequireWildcard(_reduxModulesPosts);

var _components2 = require('../../components');

var _htmlReactParser = require('html-react-parser');

var _htmlReactParser2 = _interopRequireDefault(_htmlReactParser);

var _components = {
  _$PostList: {
    displayName: 'PostList'
  }
};

var _reactComponentWrapper = _reactTransformCatchErrors3['default']({
  filename: '/var/www/websites/blog.paymentwall.com/releases/20220825105928/src/components/PostList/PostList.js',
  components: _components,
  locals: [],
  imports: [_react, _redboxReact]
});

var _reactComponentWrapper2 = _reactTransformCatchErrors3['default']({
  filename: '/var/www/websites/blog.paymentwall.com/releases/20220825105928/src/components/PostList/PostList.js',
  components: _components,
  locals: [],
  imports: [_react, _redboxReact]
});

function _wrapComponent(uniqueId) {
  return function (ReactClass) {
    return _reactComponentWrapper2(_reactComponentWrapper(ReactClass, uniqueId), uniqueId);
  };
}

var PostList = (function (_Component) {
  _inherits(PostList, _Component);

  function PostList() {
    _classCallCheck(this, _PostList);

    _Component.apply(this, arguments);
  }

  PostList.prototype.isSearchActive = function isSearchActive() {
    var _props = this.props;
    var searchActive = _props.searchActive;
    var searchValue = _props.searchValue;

    if (searchActive && searchValue.length) {
      return ' is-search-active is-search-value';
    } else if (searchActive && !searchValue.length) {
      return ' is-search-active';
    }

    return '';
  };

  PostList.prototype.renderTimeAgo = function renderTimeAgo(datetime) {
    var moment = require('moment');
    var date = new Date(datetime);
    var now = new Date(Date.now());

    if (moment(now).diff(moment(date), 'days') < 1) {
      return moment(date).fromNow();
    }

    return moment(date).format('MMM D, YYYY');
  };

  PostList.prototype.renderLoadMoreButton = function renderLoadMoreButton() {
    var _props2 = this.props;
    var showMore = _props2.showMore;
    var showing = _props2.showing;

    return _react2['default'].createElement(
      'button',
      { className: 'posts-feed__btn btn btn--bordered', onClick: function () {
          return showMore(showing + 3);
        } },
      'More posts'
    );
  };

  PostList.prototype.renderPostsFeed = function renderPostsFeed() {
    var _this = this;

    var _props3 = this.props;
    var posts = _props3.posts;
    var loading = _props3.loading;
    var showing = _props3.showing;

    if (loading) {
      return _react2['default'].createElement(_components2.AppLoader, null);
    }

    var count = 0;
    return _react2['default'].createElement(
      'div',
      { className: 'posts-feed animated fadeInUp' },
      _react2['default'].createElement(
        'div',
        { className: 'row' },
        posts.map(function (post) {
          if (count < showing && !post.sticky) {
            count++;
            return _react2['default'].createElement(
              'div',
              { className: 'col-xs-12 col-sm-6 col-md-4', key: post.id },
              _react2['default'].createElement(
                _reactRouter.Link,
                { to: '/' + post.categories.names[0].name + '/' + post.slug, className: 'post-preview' },
                _react2['default'].createElement(
                  'div',
                  { className: 'post-preview__header' },
                  _react2['default'].createElement('img', { className: 'post-preview__img', src: post.featured_image, alt: '' })
                ),
                _react2['default'].createElement(
                  'div',
                  { className: 'post-preview__content' },
                  _react2['default'].createElement(
                    'div',
                    { className: 'post-preview__sub-heading' },
                    post.subtitle ? post.subtitle.rendered : ''
                  ),
                  _react2['default'].createElement(
                    'div',
                    { className: 'post-preview__heading' },
                    post.title.rendered
                  ),
                  _react2['default'].createElement(
                    'div',
                    { className: 'post-preview__excerpt' },
                    _htmlReactParser2['default'](_utils.striptags(post.excerpt.rendered))
                  ),
                  _react2['default'].createElement(
                    'div',
                    { className: 'post-preview__post-date' },
                    _this.renderTimeAgo(post.date)
                  )
                )
              )
            );
          }
        })
      ),
      showing <= posts.length ? this.renderLoadMoreButton() : ''
    );
  };

  PostList.prototype.render = function render() {
    return _react2['default'].createElement(
      'div',
      { className: 'posts' + this.isSearchActive() },
      _react2['default'].createElement(
        'div',
        { className: 'container' },
        _react2['default'].createElement(_components2.PostCategories, null),
        this.renderPostsFeed()
      )
    );
  };

  _createClass(PostList, null, [{
    key: 'propTypes',
    value: {
      posts: _react.PropTypes.array,
      loading: _react.PropTypes.bool.isRequired,
      showing: _react.PropTypes.number.isRequired,
      showMore: _react.PropTypes.func.isRequired,
      searchActive: _react.PropTypes.bool.isRequired,
      searchValue: _react.PropTypes.string.isRequired
    },
    enumerable: true
  }]);

  var _PostList = PostList;
  PostList = _wrapComponent('_$PostList')(PostList) || PostList;
  PostList = _reactRedux.connect(function (state) {
    return {
      posts: state.posts.data,
      loading: state.posts.loading,
      showing: state.posts.showing,
      searchActive: state.search.active,
      searchValue: state.search.value
    };
  }, function (dispatch) {
    return _redux.bindActionCreators(postsActions, dispatch);
  })(PostList) || PostList;
  return PostList;
})(_react.Component);

exports['default'] = PostList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PostList/PostList.js
// module id = 668
// module chunks = 0